import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Graphic } from './Graphic';

export const graphicPropertyLayout = LockablePropertyStripLayout<Graphic>((d, s, o, w, a) => [
    // Add "container" button
    w.createButton({
        active: !!a.get('container'),
        image: 'deqo://icons/i8/box',
        text: 'Container',
        onAction() {
            o.update(() => a.set('container', x => !x));
            this.update({ active: !!a.get('container') });
        }
    }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
